import { ReactNode, useId } from 'react';

import {
  FormGroup,
  FormHelpText,
  FormInput,
  FormInputProps,
} from '@spotify-internal/encore-web';

export type FormTextFieldProps = Omit<FormInputProps, 'id' | 'error'> & {
  label: string;
  helperText?: ReactNode;
  error?: string | null;
  'data-testid'?: string;
};

export const FormTextField = ({
  label,
  helperText,
  error,
  name,
  size = 'small',
  'data-testid': dataTestId = name,
  ...inputProps
}: FormTextFieldProps) => {
  const inputId = useId();
  const helpTextId = useId();
  const helpText = error ?? helperText;

  return (
    <FormGroup label={label} labelFor={inputId} data-testid={dataTestId}>
      <FormInput
        {...inputProps}
        id={inputId}
        name={name}
        size={size}
        error={Boolean(error)}
        aria-describedby={helpText ? helpTextId : undefined}
      />
      {helpText && (
        <FormHelpText id={helpTextId} error={Boolean(error)}>
          {helpText}
        </FormHelpText>
      )}
    </FormGroup>
  );
};
